export default "__VITE_ASSET__Dm1K32cv__"